import { useEffect, useState } from 'react';

// in-app function profile: show/hide feature groups (no licence effect)
const KEY = 'giss_features';
export const FEATURE_KEYS = ['network', 'fittings', 'leak', 'leakCalc', 'hydrant', 'gas', 'kks', 'corr', 'fault', 'locate', 'tracer', 'scaffold', 'util', 'sewer', 'pits', 'survey', 'loggers', 'gnss', 'tracks', 'maint', 'lv', 'inventory', 'route', 'pressure', 'stake', 'garden', 'costs', 'facade', 'studio', 'cadio', 'proj', 'xbear', 'aqua'];
export const PRESETS = {
  garden: { network: true, fittings: true, leak: false, util: false, sewer: false, studio: true, cadio: false, proj: false, pits: false, survey: true, loggers: false, gnss: true, tracks: true, maint: false, lv: false, inventory: false, route: false, pressure: true, stake: false, garden: true, costs: true },
  pro: Object.fromEntries(FEATURE_KEYS.map((k) => [k, true])),
};
const all = PRESETS.pro;
const load = () => { try { return { ...all, ...JSON.parse(localStorage.getItem(KEY)) }; } catch { return { ...all }; } };
let feats = load();
const subs = new Set();
export const setFeatures = (p) => { feats = { ...feats, ...p }; localStorage.setItem(KEY, JSON.stringify(feats)); subs.forEach((f) => f(feats)); };
export const feat = (k) => feats[k] !== false;
export const activePreset = (f = feats) => Object.keys(PRESETS).find((p) => FEATURE_KEYS.every((k) => !!f[k] === PRESETS[p][k])) || 'custom';
export function useFeatures() {
  const [v, setV] = useState(feats);
  useEffect(() => { subs.add(setV); return () => subs.delete(setV); }, []);
  return v;
}
